// Delete Promotion
export const DELETE_PROMOTION_REQUEST = 'DELETE_PROMOTION_REQUEST';
export const DELETE_PROMOTION_DONE = 'DELETE_PROMOTION_DONE';
export const DELETE_PROMOTION_FAILED = 'DELETE_PROMOTION_FAILED';
